import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../../../networking/utils';

export const setNotificationsWidgetEmailAccountActivity = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_EMAIL_ACCOUNT_ACTIVITY`,
  (accountActivity: boolean) => ({ accountActivity })
);

export const setNotificationsWidgetEmailNews = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_EMAIL_NEWS`,
  (news: boolean) => ({ news })
);

export const setNotificationsWidgetEmailPasswordReset = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_EMAIL_PASSWORD_RESET`,
  (passwordReset: boolean) => ({ passwordReset })
);

export const setNotificationsWidgetDeviantArtProtect = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_DEVIANTART_PROTECT`,
  (protect: boolean) => ({ protect })
);

export const setNotificationsWidgetDeviantArtNewMembers = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_DEVIANTART_NEW_MEMBERS`,
  (newMembers: boolean) => ({ newMembers })
);

export const setNotificationsWidgetDeviantArtMentions = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_DEVIANTART_MENTIONS`,
  (mentions: boolean) => ({ mentions })
);

export const setNotificationsWidgetDeviantArtBadges = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_DEVIANTART_BADGES`,
  (badges: boolean) => ({ badges })
);

export const setNotificationsWidgetEmailOtp = createAction(
  `${reduxKey}.SET_NOTIFICATIONS_WIDGET_EMAIL_OTP`,
  (otp: string) => ({ otp })
);

export const {
  submit: saveNotifications,
  success: saveNotificationsSuccess,
  failure: saveNotificationsFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_NOTIFICATIONS');
